import React from 'react';
import { HeadingSmall, ParagraphMini } from '../../../../core/components';

export interface ModalSectionContainerProps {
  title: string;
  inBeta?: boolean;
  children: React.ReactNode;
}

export const ModalSectionContainer = ({ children, title, inBeta }: ModalSectionContainerProps): React.ReactElement => {
  return (
    <>
      <div className="settings-modal__title-container">
        <HeadingSmall level="h2">{title}</HeadingSmall>
        {inBeta && (
          <ParagraphMini>
            <sup style={{ color: '#0079B9' }}>BETA</sup>
          </ParagraphMini>
        )}
      </div>
      <div className="settings-modal__region-divider" />
      <div className="my-4">{children}</div>
    </>
  );
};
